import { ThemeOptions } from "@mui/material";

const palette: Exclude<ThemeOptions["palette"], undefined> = {
  background: {
    default: "#00205C",
    paper: "#FAFAFA",
  },
  primary: {
    main: "#00B189",
    contrastText: "#ffffff",
  },
  secondary: {
    main: "#F93549",
    light: "#2e2e6d80",
    contrastText: "#ffffff",
  },
  error: {
    main: "#FE5E5B",
  },
  info: {
    main: "#904CFC",
  },
  action: {
    active: "#F93549",
  },
  text: {
    primary: "#2e2e6d",
    secondary: "#00205C",
  },
};

export default palette;
